<template>
  <div class="frame frame--border frame--padding-small">
    <div class="row align-justify">
      <div class="column shrink"><h6 class="mbs">Calidad del perfil</h6></div>
      <div class="column shrink">
        <span class="text-small">{{ percentage }} completo</span>
      </div>
    </div>
    <div
      role="progressbar"
      tabindex="0"
      :aria-valuenow="percentage"
      aria-valuemin="0"
      :aria-valuetext="percentageLabel"
      aria-valuemax="100"
      class="progress progress--small mvs"
    >
      <div class="progress-meter" :style="{ width: percentageValue }" />
    </div>
    <p class="mts" v-if="percentage < 100" v-html="message"></p>
  </div>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    completeProfileUrl: {
      type: String,
      default: '/manage-profile/profile-completeness',
    },
  },
  computed: {
    percentageLabel() {
      return `${this.percentage} por ciento`;
    },
    percentageValue() {
      return `${this.percentage}%`;
    },
    message() {
      return `<a href="${this.completeProfileUrl}">Haz click</a> para completar tu perfil`;
    }
  },
};
</script>
